import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchContact, fetchEditableContact } from 'flow/actions/contact-actions';
import Page from 'flow/components/Setting/Page';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';
import { getContact, getContactKeyFromExtensionKey } from 'flow/selectors/contact-selectors';
import { selectCallRecordContact } from 'flow/selectors/call-records-selectors';
import { getExtensionKeyFromContactKey } from 'flow/selectors/ExtensionSelectors';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';
import ContactCallHistoryWidgetTW from './ContactCallHistoryWidgetTW';
import ContactHeader from './ContactHeader';
import ContactInfoCard from './ContactInfoCard';
import ContactSettingsCard from './ContactSettingsCard';
import ContactScheduleCard from './ContactScheduleCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ContactContainer = function ContactContainer(_ref) {
  var _history$location$sta;
  var parentContactKey = _ref.parentContactKey,
    parentExtensionKey = _ref.parentExtensionKey,
    callRecordKey = _ref.callRecordKey,
    calendarPath = _ref.calendarPath,
    onNavigation = _ref.onNavigation;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next,
    showDialpad = _useAppContext.showDialpad,
    setShowDialpad = _useAppContext.setShowDialpad;
  var dispatch = useAppDispatch();
  var history = useHistory();
  var isAdmin = useAppSelector(selectIsAdmin);
  var isSinglePaneMode = useAppSelector(getIsSinglePaneMode);
  var contactKey = useAppSelector(function (state) {
    return getContactKeyFromExtensionKey(state, parentExtensionKey);
  });
  contactKey = parentContactKey || contactKey;
  var extensionKey = useAppSelector(function (state) {
    return (
      //@ts-ignore
      getExtensionKeyFromContactKey(state, parentContactKey)
    );
  });
  extensionKey = parentExtensionKey || extensionKey;
  var contact = useAppSelector(function (state) {
    return getContact(state, contactKey, extensionKey) || selectCallRecordContact(state, callRecordKey);
  });
  useEffect(function () {
    if (!(contact !== null && contact !== void 0 && contact.get('editableContactDTO'))) {
      dispatch(fetchContact(contact === null || contact === void 0 ? void 0 : contact.get('key')));
      dispatch(fetchEditableContact(contact === null || contact === void 0 ? void 0 : contact.get('key')));
    }
  }, [dispatch, contact]);
  var propsWithKeys = {
    contactKey: contactKey,
    extensionKey: extensionKey,
    callRecordKey: callRecordKey,
    contact: contact,
    onNavigation: onNavigation
  };
  var onClickSettingsOnBehalf = function onClickSettingsOnBehalf() {
    if (showDialpad) {
      setShowDialpad(false);
    }
    history.push(generatePath(routes['settings'], {
      extensionKey: extensionKey
    }));
  };
  return /*#__PURE__*/_jsx(Page, {
    childrenClassName: "w-full",
    className: "bg-gray-200 dark:bg-white",
    discardHeader: false,
    action: isAdmin && extensionKey && /*#__PURE__*/_jsx(IconButton, {
      tooltipLabel: i18next.t('settings_on_behalf.edit_user_settings'),
      onClick: onClickSettingsOnBehalf,
      children: /*#__PURE__*/_jsx(Icon, {
        iconKey: "setting_menu"
      })
    }),
    onClickBack: (_history$location$sta = history.location.state) !== null && _history$location$sta !== void 0 && _history$location$sta.from ? function () {
      var _history$location$sta2;
      return history.push((_history$location$sta2 = history.location.state) === null || _history$location$sta2 === void 0 ? void 0 : _history$location$sta2.from);
    } : isSinglePaneMode ? function () {
      return history.push(routes['extensions']);
    } : undefined,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex flex-col items-center px-6",
      children: /*#__PURE__*/_jsxs("div", {
        className: "@container relative flex w-full max-w-screen-md flex-col gap-y-6",
        children: [/*#__PURE__*/_jsx(ContactHeader, _objectSpread({}, propsWithKeys)), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-start gap-6 @2xl:flex-row",
          children: [/*#__PURE__*/_jsx(ContactInfoCard, _objectSpread({}, propsWithKeys)), /*#__PURE__*/_jsxs("div", {
            className: "flex w-full min-w-1/2 flex-col gap-6 @2xl:w-auto",
            children: [/*#__PURE__*/_jsx(ContactSettingsCard, _objectSpread({}, propsWithKeys)), /*#__PURE__*/_jsx(ContactScheduleCard, _objectSpread(_objectSpread({}, propsWithKeys), {}, {
              calendarPath: calendarPath
            })), /*#__PURE__*/_jsx(ContactCallHistoryWidgetTW, _objectSpread({}, propsWithKeys))]
          })]
        })]
      })
    })
  });
};
export default /*#__PURE__*/React.memo(ContactContainer);